"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _styles = require("../styles");

var _Lazyload = _interopRequireDefault(require("../Lazyload"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Item =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Item, _React$Component);

  function Item() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Item.prototype;

  _proto.handleChange = function handleChange(value, _, checked) {
    var onChange = this.props.onChange;
    if (onChange) onChange(checked, value);
  };

  _proto.renderChildren = function renderChildren(content) {
    var _this$props = this.props,
        placeholder = _this$props.placeholder,
        container = _this$props.container;
    if (!placeholder) return content;
    return _react.default.createElement(_Lazyload.default, {
      container: container,
      placeholder: placeholder
    }, content);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        style = _this$props2.style,
        className = _this$props2.className,
        container = _this$props2.container,
        children = _this$props2.children,
        placeholder = _this$props2.placeholder,
        value = _this$props2.value,
        others = _objectWithoutPropertiesLoose(_this$props2, ["style", "className", "container", "children", "placeholder", "value"]);

    var cls = (0, _classnames.default)((0, _styles.cardGroupClass)('item'), className);
    var showCheck = others.checked !== undefined;

    var content = _react.default.createElement(_react.Fragment, null, children, showCheck && _react.default.createElement(_Checkbox.default, _extends({}, others, {
      onChange: this.handleChange.bind(this, value),
      className: (0, _styles.cardGroupClass)('checkbox')
    })));

    return _react.default.createElement("div", {
      style: style,
      className: cls
    }, this.renderChildren(content));
  };

  return Item;
}(_react.default.Component);

Item.propTypes = {
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  container: _propTypes.default.object,
  children: _propTypes.default.element,
  placeholder: _propTypes.default.element,
  onChange: _propTypes.default.func,
  value: _propTypes.default.any,
  checked: _propTypes.default.oneOfType([_propTypes.default.oneOf([true, false, 'indeterminate']), _propTypes.default.func])
};
var _default = Item;
exports.default = _default;